import APIServices from './APIServices'

// Cache para evitar requests duplicadas
let providersCache: any = null
let cacheTimestamp = 0
const CACHE_DURATION = 5 * 60 * 1000 // 5 minutos

export const getProviders = async (params: {
  page?: number
  per_page?: number
  search?: string
  type?: string
}) => {
  // Si es una búsqueda vacía y tenemos cache válido, usar cache
  if (!params.search && providersCache && (Date.now() - cacheTimestamp < CACHE_DURATION)) {
    return providersCache
  }
  
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params || {}).filter(([_, value]) => value != null)
    )
    const finalParams = { ...cleanParams, type: 'PROVIDER' }
    
    const response = await APIServices.get('/cargo/company', { params: finalParams })
    
    const items = response.data?.items || []
    
    // Si es búsqueda vacía, guardar en cache
    if (!params.search) {
      providersCache = items
      cacheTimestamp = Date.now()
    }
    
    return items
  } catch (error) {
    console.error('Error fetching providers:', error)
    throw error
  }
}

export const getImporters = async (params: {
  page?: number
  per_page?: number
  search?: string
  type?: string
}) => {
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params || {}).filter(([_, value]) => value != null)
    )
    const finalParams = { ...cleanParams, type: 'IMPORTER' }
    const response = await APIServices.get('/cargo/company', { params: finalParams })
    return response.data?.items || []
  } catch (error) {
    console.error('Error fetching importers:', error)
    throw error
  }
}

export const getTransporters = async (params: {
  page?: number
  per_page?: number
  search?: string
  type?: string
}) => {
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params || {}).filter(([_, value]) => value != null)
    )
    const finalParams = { ...cleanParams, type: 'TRANSPORTER' }
    const response = await APIServices.get('/cargo/company', { params: finalParams })
    return response.data?.items || []
  } catch (error) {
    console.error('Error fetching transporters:', error)
    throw error
  }
}

export const getStorages = async (params: {
  page?: number
  per_page?: number
  search?: string
  type?: string
}) => {
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params || {}).filter(([_, value]) => value != null)
    )
    const finalParams = { ...cleanParams, type: 'STORAGE' }
    const response = await APIServices.get('/cargo/company', { params: finalParams })
    return response.data?.items || []
  } catch (error) {
    console.error('Error fetching storages:', error)
    throw error
  }
}

export const getManagers = async (params: {
  page?: number
  per_page?: number
  search?: string
  type?: string
}) => {
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params || {}).filter(([_, value]) => value != null)
    )
    const finalParams = { ...cleanParams, type: 'MANAGER' }
    const response = await APIServices.get('/cargo/company', { params: finalParams })
    return response.data?.items || []
  } catch (error) {
    console.error('Error fetching managers:', error)
    throw error
  }
}
